import { render, staticRenderFns } from "./DashboardCustomization.vue?vue&type=template&id=bf4c2c00&scoped=true"
import script from "./DashboardCustomization.vue?vue&type=script&lang=js"
export * from "./DashboardCustomization.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomization.vue?vue&type=style&index=0&id=bf4c2c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4c2c00",
  null
  
)

export default component.exports